<template lang="pug">
  .container.grid-xl
    page-title(icon="fas fa-boxes" :title="title" :subtitle="subtitle")
    .flex-centered.full-height(v-if="error") #[error-box(:error="error")]
    fieldset(v-else :disabled="loading")
      form(@submit.prevent="onSubmit")
        .columns
          .column.col-6.col-lg-7.col-md-8.col-sm-12
            form-group(label="Título" :validation="$v.collection" field="title")
              input.form-input(v-model.trim="$v.collection.title.$model")
            form-group(label="Resumo" :validation="$v.collection" field="brief")
              textarea.form-input(rows="5" v-model.trim="$v.collection.brief.$model")
            form-group(label="Tipo da coleção" :validations='$v.collection' field="collectionType")
              select.form-select(v-model="$v.collection.collectionType.$model")
                option(v-for="label, value in collectionTypes" :value="value") {{ label }}
            .divider
            form-group(label="Produtos")
              products-autocomplete(v-model="collection.products" :collection-type="collection.collectionType")
            .divider
            form-group(label="Capa" :validation="$v.collection" field="cover")
              file-upload(
                v-model="$v.collection.cover.$model"
                :input-attrs="{ accept: 'image/*' }"
                @upload-start="uploading = true"
                @upload-end="uploading = false"
              )
            form-switch(label="Ativo" v-model="$v.collection.status.$model")
            form-switch(label="Permitir filtrar na busca" v-model="$v.collection.searchable.$model")
            .divider
            .text-right
              button.btn.btn-primary(:disabled="disabled") Salvar
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import collections from '@/services/collections'
import { collectionTypes } from '@/lib/constants'

export default {
  computed: {
    collectionTypes() {
      return collectionTypes
    },
    disabled() {
      return this.uploading || this.loading || this.$v.$invalid
    },
    title() {
      return this.$route.params.id ? 'Editar coleção' : 'Nova coleção'
    },
    subtitle() {
      return 'Coleções agrupam os produtos dos planos'
    },
    body() {
      return {
        ...this.collection,
        products: this.collection.products.map(product => product.id),
      }
    },
  },
  data() {
    return {
      loading: false,
      uploading: false,
      error: null,
      collection: {
        title: '',
        brief: '',
        cover: '',
        status: true,
        products: [],
        searchable: false,
        collectionType: 'magazine',
      },
    }
  },
  methods: {
    async onSubmit() {
      const { body } = this
      const submitFunction = body.id ? collections.update : collections.create
      try {
        this.loading = true
        await submitFunction(body)
        this.$toaster.success('Coleção salva')
        this.$router.back()
      } catch (e) {
        this.$toaster.error(e.message)
      } finally {
        this.loading = false
      }
    },
  },
  validations: {
    collection: {
      title: { required },
      brief: {},
      searchable: {},
      cover: {},
      status: { required },
      collectionType: { required },
    },
  },
  async created() {
    if (!this.$route.params.id) return
    try {
      this.loading = true
      const { data } = await collections.show(this.$route.params.id)
      this.collection = data
    } catch (e) {
      this.error = e
    } finally {
      this.loading = false
    }
  },
}
</script>
